import React from 'react';
import { SvgIcon } from '../../../common/SvgIcon';
import { simpleIconPropsTypes } from '../../propTypes';

export const IconMarketing = (props) => {
  const { width = 22, height = 22 } = props;

  // Visual constants (tuned to match screenshot)
  const barW = 2.4;
  const r = 1.2;
  const baseY = 17.2;
  const baseH = 2.6;

  // Bottom of bars aligns to baseline top (baseY)
  const bars = [
    { x: 4.2, h: 8.2 }, // short
    { x: 7.9, h: 11.2 }, // tall
    { x: 11.6, h: 6.9 }, // medium-short
    { x: 15.3, h: 14.6 }, // tallest
  ];

  return (
    <SvgIcon width={width} height={height} viewBox="0 0 22 22">
      {/* Bars */}
      {bars.map((b, idx) => (
        <rect key={idx} x={b.x} y={baseY - b.h} width={barW} height={b.h} rx={r} fill="currentColor" />
      ))}

      {/* Baseline (drawn last to "trim" bar bottoms and keep it perfectly even) */}
      <rect x="2" y={baseY} width="18" height={baseH} rx={baseH / 2} fill="currentColor" />
    </SvgIcon>
  );
};

IconMarketing.propTypes = simpleIconPropsTypes;
